import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import Areas from "./sections/Areas";
import JonesboroCallout from "./sections/JonesboroCallout";
import Services from "./sections/Services";
import LocalService from "./sections/LocalService";
import HowItWorks from "./sections/HowItWorks";
import Directory from "./sections/Directory";
import ServiceAreaFaq from "./sections/ServiceAreaFaq";
import Neighborhood from "./sections/Neighborhood";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <Areas />
      <JonesboroCallout />
      <Services />
      <LocalService />
      <HowItWorks />
      <Directory />
      <ServiceAreaFaq />
      <Neighborhood />
      <Footer />
    </div>;
}